module.exports = __webpack_public_path__ + "static/media/card-blog1.11ea313a.jpg";